module.exports = __webpack_public_path__ + "static/media/bg_competences_mobile.4af0a107.jpg";